import api from './api';
import StorageService from './StorageService';

class ProjectTeamService {
    // Get all project team members
    static async getAll(page = 1, limit = 20, filters = {}) {
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...filters
            });
            const response = await api.get(`/project-teams?${params}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get project team member by ID
    static async getById(id) {
        try {
            const response = await api.get(`/project-teams/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get project team by project ID
    static async getByProjectId(projectId) {
        try {
            const response = await api.get(`/project-teams/project/${projectId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Create new project team member
    static async create(data) {
        try {
            const payload = { ...data, createdBy: StorageService.loginData().employeeId };
            const response = await api.post('/project-teams', payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update project team member
    static async update(id, data) {
        try {
            const payload = { ...data, updatedBy: StorageService.loginData().employeeId };
            const response = await api.put(`/project-teams/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Update project team member status
    static async updateStatus(id, status) {
        try {
            const payload = { status, updatedBy: StorageService.loginData().employeeId };
            const response = await api.patch(`/project-teams/${id}/status`, payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Create multiple team members (bulk)
    static async createBulk(teamMembers) {
        try {
            const response = await api.post('/project-teams/bulk', { teamMembers });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default ProjectTeamService;